export default __webpack_public_path__ + "static/hram-ikony-bozhiej-materi-sporitelnica-hlebov-krovlya_8-b5998b9be68a4b0a1a23bf7304ddd012.jpg";